import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';

const StyledCloseButton = styled(Box)`
  position: absolute;
  right: 12px;
  top: 12px;
  cursor: pointer;
`;

const StyledBox = styled(Box)`
  .fade-in {
    opacity: 0.1;
    transition: opacity 0.5s ease-in-out;
  }
  
  .fade-in.active {
    opacity: 1;
  }
`;

const StyledTypography = styled(Typography)`  
  strong {
    font-weight: bold;
  }

  a {
    color: #820AD1;
    text-decoration: underline;
    max-width: 300px;
    word-break: break-all;
    font-weight: bold;
  }
`;

function QuestionModal({ closeModal, title, answer }) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    // Trigger animation after a short delay to ensure proper rendering
    setTimeout(() => setActive(true), 10);
  }, []);

  const handleClose = () => {
    setActive(false);
    setTimeout(closeModal, 100);
  };

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <StyledBox
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems={{ xs: 'start', lg: 'center' }}
      paddingTop={{ xs: '40px', lg: '0' }}
      backgroundColor="rgba(0, 0, 0, 0.7)"
      zIndex="999"
      overflow="scroll"
      onClick={handleOverlayClick}
    >
      <StyledBox
        backgroundColor="white.default"
        paddingTop="30px"
        paddingBottom="30px"
        paddingRight="43px"
        paddingLeft="29px"
        borderRadius="12px"
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
        position="relative"
        width={{ xs: '100%', md: '930px' }}
        display="flex"
        flexDirection="column"
        alignItems={{ xs: 'left', md: 'center' }}
        margin={{ xs: '8x', md: '0' }}
        className={`fade-in ${active ? 'active' : ''}`}
      >
        <StyledCloseButton onClick={closeModal}>
          <Image
            alt="Cerrar"
            src="benefits/close-big.svg"
            webp={false}
            width="auto"
            importance="high"
          />
        </StyledCloseButton>

        <Typography
          marginTop="30px"
          variant="heading4"
          strong
          textAlign={{ xs: 'left', md: 'center' }}
          maxWidth={{ xs: '100%', md: '459px' }}
          color="primary"
        >
          {title}
        </Typography>

        <StyledTypography
          variant="paragraph1"
          marginTop={{ xs: '20px', md: '35px' }}
          marginBottom={{ xs: '20px', md: '35px' }}
          maxWidth={{ xs: '100%', md: '459px' }}
          dangerouslySetInnerHTML={{ __html: answer }}
        />

      </StyledBox>
    </StyledBox>
  );
}

QuestionModal.propTypes = {
  answer: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default QuestionModal;
